export default "__VITE_ASSET__vZ1eiLKF__"